import type { UploadResponse, OkkoUploadOptions } from '@/types/upload.types';
import { ApiResponse } from '@/types/services';

import { baseApi } from './base-api';

export type UploadApiResponse = ApiResponse<UploadResponse>;
export const uploadApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    uploadOkkoPrices: builder.mutation<UploadResponse, { file: File; options: OkkoUploadOptions }>({
      query: ({ file, options }) => {
        const formData = new FormData();

        formData.append('file', file);
        formData.append('createOrder', (options.createOrder ?? false).toString());

        if (options.createOrder) {
          formData.append('sendSMS', (options.sendSMS || false).toString());
          formData.append('sendMail', (options.sendMail || false).toString());
          formData.append('send1C', (options.send1C || false).toString());
          formData.append('sendOkkoCore', (options.sendOkkoCore || false).toString());

          if (options.notificationDateTime) {
            formData.append('notification_datetime', new Date(options.notificationDateTime).toISOString());
          }
        }

        return {
          url: `upload/okko-prices`,
          method: 'POST',
          body: formData
        };
      },
      transformResponse: (response: UploadApiResponse): UploadResponse => ({
        message: response.data.message,
        processedRecords: response.data.processedRecords || 0,
        cid: response.data.cid,
        scheduledNotifications: response.data.scheduledNotifications
      })
    }),

    uploadCompetitorPrices: builder.mutation<UploadResponse, File>({
      query: file => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `upload/competitor-prices`,
          method: 'POST',
          body: formData
        };
      },
      transformResponse: (response: UploadApiResponse): UploadResponse => response.data
    }),

    uploadDiscounts: builder.mutation<UploadResponse, File>({
      query: file => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `upload/discounts`,
          method: 'POST',
          body: formData
        };
      },
      transformResponse: (response: UploadApiResponse): UploadResponse => response.data
    }),

    uploadCompetitorsData: builder.mutation<UploadResponse, File>({
      query: file => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `upload/competitors-data`,
          method: 'POST',
          body: formData
        };
      },
      transformResponse: (response: UploadApiResponse): UploadResponse => response.data
    })
  }),

  overrideExisting: false
});

export const {
  useUploadDiscountsMutation,
  useUploadOkkoPricesMutation,
  useUploadCompetitorsDataMutation,
  useUploadCompetitorPricesMutation
} = uploadApi;
